import React, { Component } from 'react';
import { connect } from 'react-redux';
import MapaGoogle from '../mapa/mapaGoogle';
import { Marker } from 'react-google-maps';

import ImgClotrollerBlue from '../image/controller-blue.png';
import ImgClotrollerGrey from '../image/controller-grey.png';
// import { GoogleMap } from "react-google-maps";
// import { getLocalCEP } from './controladorActions';

class MapaControlador extends Component {
  constructor(props) {
    super(props);

    this.handleMarkerMouseUp = this.handleMarkerMouseUp.bind(this);
    this.handleMapClick = this.handleMapClick.bind(this);
    this.renderMarker = this.renderMarker.bind(this);
    this.testeRotacionaimg = this.testeRotacionaimg.bind(this);

    this.state = {
      draggedPosition: null, // Armazena posição arrastada pelo usuário
    };
  }

  handleMapClick(e) {
    try {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      window.$('#controador_latitude').val(lat);
      window.$('#controador_longitude').val(lng);
      if (this.props.onPositionChange) {
        try {
          this.props.onPositionChange(lat, lng);
        } catch (err) {
          console.log('onPositionChange callback error:', err);
        }
      }
      this.setState({ draggedPosition: { lat, lng } });
    } catch (err) {
      console.log('Erro em handleMapClick', err);
    }
  }

  handleMarkerMouseUp(marker) {
    const lat = marker.latLng.lat();
    const lng = marker.latLng.lng();

    window.$('#controador_latitude').val(lat);
    window.$('#controador_longitude').val(lng);

    // Notifica o pai (controladorForm) se houver callback
    if (this.props.onPositionChange) {
      try {
        this.props.onPositionChange(lat, lng);
      } catch (e) {
        console.log('onPositionChange callback error:', e);
      }
    }

    // Armazena a posição arrastada para evitar que volte ao original
    this.setState({
      draggedPosition: {
        lat: lat,
        lng: lng,
      },
    });
  }

  renderMarker(handleMarkerMouseUp) {
    const list = this.props.list || [];

    let markers = [];
    let markerAtual = null;
    let markerKey = 0;

    if (list.length) {
      for (var key in list) {
        if (list[key].id === this.props['data-contId']) {
          // Usa posição arrastada se existir, caso contrário usa a posição das props
          const position = this.state.draggedPosition || {
            lat: this.props['data-latitude'],
            lng: this.props['data-longitude'],
          };

          markerAtual = (
            <Marker
              key={list[key].id}
              position={position}
              draggable={true}
              icon={ImgClotrollerBlue}
              // icon={{
              //     url: "http://www.geocodezip.com/mapIcons/SO_20170925_multiplePaths_mod.svg"
              // }}
              onDragEnd={e => {
                this.handleMarkerMouseUp(e);
              }}
              onMouseUp={e => {
                this.handleMarkerMouseUp(e);
              }}
            />
          );
        } else {
          markers.push(
            <Marker
              key={list[key].id}
              position={{ lat: list[key].latitude, lng: list[key].longitude }}
              draggable={false}
              icon={ImgClotrollerGrey}

              //onMouseUp={this.handleMarkerMouseUp}
            />,
          );
        }

        markerKey = list[key].id;
      }
    }

    // se for regitro novo tem que criar usando o centro do cep
    if ((this.props['data-contId'] === null || this.props['data-contId'] === undefined)) {
      window.$('#controador_latitude').val(this.props.latitude);
      window.$('#controador_longitude').val(this.props.longitude);

      // Usa posição arrastada se existir, caso contrário usa a posição das props
      const position = this.state.draggedPosition || { lat: this.props.latitude, lng: this.props.longitude };

      markers.push(
        <Marker
          key={markerKey + 1}
          position={position}
          draggable={true}
          icon={ImgClotrollerBlue}
          onDragEnd={e => {
            this.handleMarkerMouseUp(e);
          }}
          onMouseUp={e => {
            this.handleMarkerMouseUp(e);
          }}
        />,
      );
    }

    if ((markerAtual !== null && markerAtual !== undefined)) {
      markers.push(markerAtual);
    }

    return markers;
  }

  testeRotacionaimg(map) {
    var rotationAngle = 10;

    setInterval(function() {
      window.$('img[src="http://www.geocodezip.com/mapIcons/SO_20170925_multiplePaths_mod.svg"]').css({
        transform: 'rotate(' + rotationAngle + 'deg)',
        'transform-origin': '39px 60px',
      });
      rotationAngle += 10;
      rotationAngle %= 360;
    }, 1000);
  }

  render() {
    return (
      // <div>
      <MapaGoogle
        containerElement={<div style={{ height: '80vh', width: '100%' }} />}
        mapElement={<div style={{ height: `100%` }} />}
        defaultCenter={{ lat: this.props['data-latitude'], lng: this.props['data-longitude'] }}
        onClick={this.handleMapClick}
      >
        {this.renderMarker()}
      </MapaGoogle>
      /* <input type='button' value='teste' onClick={this.testeRotacionaimg} /> */
      // </div>
    );
  }
}

const mapStateToProps = state => ({ list: state.controladorCad.list });
export default connect(
  mapStateToProps,
  null,
)(MapaControlador);
